export const config = {
  addonServices: ['Mixing', 'Transcription', 'Arrangement'],
  offlineServices: ['Pre-production'],
  linksByName: {
    'Henrique Vilhena': 'https://calendly.com/henriquevilhena/mix-session',
    'Pedro Araújo': 'https://musiversal.typeform.com/to/k2MXXWe7'
  }
};
